import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LockKeyhole } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { PlatformAddOn } from '../types/userManagement';

interface RequireAddOnProps {
  addOn: PlatformAddOn;
  redirectTo?: string;
  showAccessDenied?: boolean;
}

export default function RequireAddOn({
  addOn,
  redirectTo = '/',
  showAccessDenied = false,
}: RequireAddOnProps) {
  const { hasAddOn } = useAuth();
  const location = useLocation();

  if (hasAddOn(addOn)) {
    return <Outlet />;
  }

  if (!showAccessDenied) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{
          from: location.pathname,
          accessDenied: true,
        }}
      />
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-3xl border border-strivre-lightnavy bg-white p-10 text-center shadow-sm">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-strivre-lightburgundy">
          <LockKeyhole
            size={28}
            className="text-strivre-burgundy"
          />
        </div>

        <h1 className="text-2xl font-bold text-strivre-navy">
          Subscription Required
        </h1>

        <p className="mt-3 text-sm leading-relaxed text-strivre-mutedtext">
          Your current subscription does not include access to this module.
          Contact your administrator or update your subscription to continue.
        </p>
      </div>
    </div>
  );
}